import React, {useCallback, useState} from 'react';
import {useParams} from 'react-router-dom';

import {useBulkActionDialog} from 'src/components/bulk-tool/useBulkActionDialog';
import {useEventTracking} from 'src/hooks/useEventTracking';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';

import {CreateGroupModal} from './create-group.modal';

export const CreateGroupDialog = () => {
    const queryParams = useParams<{accountId: string}>();
    const accountId = queryParams.accountId ? +queryParams.accountId : -1;

    const [shown, setShown] = useState(false);
    const {groupOpen, groupSubmit} = useEventTracking();

    const openAddGroupModal = useCallback(() => {
        setShown(true);
        groupOpen({viewType: 'New Group'});
    }, [groupOpen]);

    const closeAddGroupModal = useCallback((submit: boolean) => {
        setShown(false);
        groupSubmit({viewType: 'New Group', submit});
    }, [groupSubmit]);

    const {onClose, onPendingChange} = useBulkActionDialog(() => closeAddGroupModal(false));

    return (
        <>
            <Button variant="Type.PRIMARY" onClick={openAddGroupModal}>
                Add Group
            </Button>
            <Dialog
                shown={shown}
                setShown={onClose}
                wrapperProps={{style: {width: 877, height: 'fit-content'}}}>
                <CreateGroupModal
                    accountId={accountId}
                    onCloseModal={submit => submit ? closeAddGroupModal(true) : onClose()}
                    onPendingChange={onPendingChange}
                />
            </Dialog>
        </>
    );
};
